import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import useCheckCallConnected from "../../hooks/useCheckCallConnected";
import useLanguageChange from "../../hooks/useLanguageChange";
import { dualStreamEnabled } from "../../shared/utility";
import livePointerService from "../LivePointer/livePointerService";
import { CALL_BODY_SCREEN } from "../../constants/Constants";
import GalleryViewTooltip from "../UI/Tooltip/GalleryViewTooltip";
import useShowGalleryViewTooltip from "../../hooks/useShowGalleryViewTooltip";
import { isvideoenabled } from "../Twilio/Room/roomFunction";

const LivePointerButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    const localisedValues = useLanguageChange();
    const showGalleryViewTooltip = useShowGalleryViewTooltip();

    const { expandView, currentCallBodyScreen } = useSelector((state) => state.commonReducer);

    const toggleLivePointer = (fromWhere, msg, toastmsg) => {
        livePointerService.toggleLivePointer(fromWhere, msg, toastmsg);
    };

    return (
        <>
            {livePointerService.isLivePointerButtonAvailable() && (
                <div className='action-button live-pointer-action-button' data-testid='livePointerButton-component'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className={clsx("call-action-btn", livePointerService.checkLivePointerStatus() && isvideoenabled() && "active")}
                            disabled={
                                (dualStreamEnabled() && !expandView) ||
                                isCallNotConnected ||
                                !livePointerService.checkLivePointerButtonEnabled() ||
                                currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN
                            }
                            onClick={() => toggleLivePointer(false, undefined, "1")}
                            data-testid='livePointer-button'
                        >
                            <span className='action-button-icon'>
                                <span
                                    className={clsx(
                                        "for-icon",
                                        livePointerService.checkLivePointerStatus() && isvideoenabled() ? "icon-start-pointer" : "icon-pointer"
                                    )}
                                ></span>
                            </span>
                            <span className='for-text'>
                                {livePointerService.checkLivePointerStatus() && isvideoenabled()
                                    ? localisedValues?.stop_pointer
                                    : localisedValues?.pointer}
                            </span>
                        </button>
                        {showGalleryViewTooltip && !livePointerService.checkLivePointerButtonEnabled() && (
                            <GalleryViewTooltip localisedValues={localisedValues} />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default LivePointerButton;
